import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { CalendarComponent } from './calendar/calendar.component';
import { UiDateRangeComponent } from './ui-date-range/ui-date-range.component';
import { DateRangePipe } from './ui-date-range/date-range.pipe';
import { CalendarMonthViewComponent }
    from './calendar/calendar-month-view/calendar-month-view.component';
import { CalendarYearViewComponent }
    from './calendar/calendar-year-view/calendar-year-view.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MomentModule,
        TranslateModule,
    ],
    declarations: [
        UiDateRangeComponent,
        CalendarComponent,
        CalendarMonthViewComponent,
        CalendarYearViewComponent,
        DateRangePipe,
    ],
    exports: [UiDateRangeComponent, DateRangePipe],
})
export class CalendarModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/calendar.module.ts